export default {
  methods: {
    itemCommandFilter (command) {
      return this.addCommandParam(this.withChildrenItemCommandFilter(command), 'children', true)
    },
    withChildrenItemCommandFilter (command) {
      // Do not change.  Overridden.
      return command
    },
    saveCommandFilter (command) {
      return this.itemCommandFilter(this.withChildrenSaveCommandFilter(command))
    },
    withChildrenSaveCommandFilter (command) {
      // Do not change.  Overridden.
      return command
    }
  }
}
